module.exports = __webpack_public_path__ + "img/7.426fc443.webp";